module.exports = __webpack_public_path__ + "assets/img/logo-visa.4022f029.svg";